import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Copy, Check } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function DomainCTA() {
  const {
    t
  } = useLanguage();
  const [copied, setCopied] = useState(false);
  const email = 'jose@danceforfans.com';
  const handleCopy = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <section className="py-32 px-6 relative overflow-hidden" data-id="element-34">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-magenta-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-35" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-37">
          <h2 className="font-serif text-4xl md:text-6xl mb-8" data-id="element-38">
            {t('domain.title')}
          </h2>
          <p className="text-xl text-zinc-400 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-39">
            {t('domain.descStart')}
            <span className="text-zinc-200 font-medium" data-id="element-40">
              {t('domain.descHighlight')}
            </span>{' '}
            {t('domain.descEnd')}
          </p>

          <div className="bg-zinc-900/80 backdrop-blur-sm border border-zinc-800 p-8 md:p-12 rounded-3xl max-w-xl mx-auto shadow-2xl" data-id="element-41">
            <p className="text-sm text-zinc-500 uppercase tracking-widest mb-6" data-id="element-42">
              {t('domain.directContact')}
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8" data-id="element-43">
              <a href={`mailto:${email}`} className="flex items-center gap-3 text-2xl md:text-3xl font-serif text-magenta-500 hover:text-magenta-400 transition-colors break-all" data-id="element-44">
                <Mail className="w-7 h-7 shrink-0" data-id="element-45" />
                <span data-id="element-46">{email}</span>
              </a>

              <button onClick={handleCopy} className="p-3 bg-zinc-800 hover:bg-zinc-700 rounded-full transition-colors text-zinc-400 hover:text-zinc-200" aria-label="Copy email address" data-id="element-47">
                {copied ? <Check className="w-5 h-5 text-green-500" data-id="element-48" /> : <Copy className="w-5 h-5" data-id="element-49" />}
              </button>
            </div>

            <p className="text-zinc-400" data-id="element-50">
              {t('domain.askForStart')}
              <span className="text-zinc-200 font-medium" data-id="element-51">
                {t('domain.askForHighlight')}
              </span>
              {t('domain.askForEnd')}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}